import { render, staticRenderFns } from "./delete_milestone_modal.vue?vue&type=template&id=694ff786"
import script from "./delete_milestone_modal.vue?vue&type=script&lang=js"
export * from "./delete_milestone_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports